import { convertRowsToData } from '../utils/dataUtils'

export default function HeatMapDataController(pivotRows) {
  //Twist the table:
  let ph = pivotRows[0]
  let rows = pivotRows
    .slice(1)
    .map(pr => {
      return pr.slice(1).map((c, j) => {
        return [pr[0] + '-' + ph[j + 1], pr[0], ph[j + 1], c]
      })
    })
    .flat()

  let propperHeaders = ['id', 'x', 'y', 'color']

  let data = convertRowsToData([propperHeaders, ...rows], 3)

  return data.map(point => {
    return {
      id: point.id, //point.value.find((d)=>d.id==='x').value+'_'+point.value.find((d)=>d.id==='y').value
      x: point.value.find(d => d.id === 'x').value,
      y: point.value.find(d => d.id === 'y').value,
      color: point.value.find(d => d.id === 'color').value,
      value: point.value.find(d => d.id === 'color').value,
    }
  })
}
